import RegisterForm from "../../components/PartnerTable/AddPartner";
import { OFF_WHITE } from "../../constants/layout";
import { Box } from "@mui/material";

const AddPartner = () => {
  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: OFF_WHITE,
        px: { xs: 3, sm: 5, md: 6, lg: 8 },
        py: { xs: 3, md: 4 },
      }}
    >
      <RegisterForm variant="page" />
    </Box>
  );
};

export default AddPartner;
